import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class FreespinsTriggered extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        let record = gameplay.getCurrentRecord();

        if (!(record instanceof SpinRecord) && record.lastChild) {
            record = record.parent;
        }

        return record.getFreespinsWon() > 0 && gameplay.areFreespinsPending() ? Exit.True : Exit.False;
    }
}
